export interface CategoryItem {
  id: string;
  name: string;
  description: string;
  icon: string;
}

export const categories: CategoryItem[] = [
  {
    id: 'all',
    name: '全部服务',
    description: '浏览开云平台为您提供的全方位服务内容',
    icon: 'ri-apps-line',
  },
  {
    id: 'entertainment',
    name: '娱乐服务',
    description: '汇聚多元化娱乐服务，打造沉浸式互动体验',
    icon: 'ri-gamepad-line',
  },
  {
    id: 'sports',
    name: '体育竞技',
    description: '覆盖全球热门体育赛事，实时数据更新',
    icon: 'ri-football-line',
  },
  {
    id: 'lifestyle',
    name: '品质生活',
    description: '精选优质生活服务，全方位提升生活品质',
    icon: 'ri-heart-pulse-line',
  },
  {
    id: 'technology',
    name: '科技创新',
    description: '前沿技术驱动，智能算法加持',
    icon: 'ri-cpu-line',
  },
];

export interface ProductItem {
  id: string;
  categoryId: string;
  name: string;
  description: string;
  features: string[];
  image: string;
  badge?: string;
}

export const products: ProductItem[] = [
  {
    id: 'prod-ent-1',
    categoryId: 'entertainment',
    name: '沉浸式互动平台',
    description: '采用前沿互动技术，打造高沉浸感的数字娱乐空间，支持多端同步体验，随时随地畅享精彩内容。',
    features: ['多端同步', '实时互动', '高清画质'],
    image: 'https://readdy.ai/api/search-image?query=Luxurious%20modern%20digital%20entertainment%20space%20with%20immersive%20warm%20golden%20ambient%20lighting%2C%20high%20tech%20interactive%20display%20screens%2C%20elegant%20dark%20interior%20design%20with%20amber%20accents%2C%20premium%20media%20room%20aesthetic%2C%20soft%20atmospheric%20glow&width=800&height=600&seq=kaiyun-cat-ent-1&orientation=landscape',
    badge: '热门',
  },
  {
    id: 'prod-ent-2',
    categoryId: 'entertainment',
    name: '社交互动社区',
    description: '连接志同道合的用户群体，丰富的社区功能与互动玩法，构建充满活力的线上社交生态。',
    features: ['社区互动', '兴趣匹配', '活动赛事'],
    image: 'https://readdy.ai/api/search-image?query=Modern%20social%20community%20hub%20with%20warm%20atmospheric%20lighting%2C%20diverse%20people%20interacting%20in%20a%20stylish%20lounge%20setting%2C%20clean%20minimalist%20design%20with%20golden%20accents%2C%20friendly%20vibrant%20atmosphere%2C%20soft%20natural%20light%20through%20large%20windows&width=800&height=600&seq=kaiyun-cat-ent-2&orientation=landscape',
  },
  {
    id: 'prod-ent-3',
    categoryId: 'entertainment',
    name: '影音内容中心',
    description: '海量正版高清影音资源，智能推荐算法精准匹配，为您打造专属的视听娱乐空间。',
    features: ['海量资源', '智能推荐', '极速播放'],
    image: 'https://readdy.ai/api/search-image?query=Elegant%20modern%20home%20theater%20room%20with%20warm%20golden%20ambient%20lighting%2C%20large%20display%20screen%20with%20premium%20audio%20system%2C%20luxurious%20dark%20interior%20design%2C%20comfortable%20seating%20with%20soft%20textiles%2C%20sophisticated%20entertainment%20setup&width=800&height=600&seq=kaiyun-cat-ent-3&orientation=landscape',
  },
  {
    id: 'prod-sports-1',
    categoryId: 'sports',
    name: '全球赛事中心',
    description: '覆盖全球200+体育赛事，实时数据更新，专业分析团队提供深度赛事解读与前瞻预测。',
    features: ['实时数据', '专业分析', '赛事覆盖'],
    image: 'https://readdy.ai/api/search-image?query=Dynamic%20modern%20sports%20analytics%20center%20with%20multiple%20large%20display%20screens%20showing%20live%20data%2C%20warm%20golden%20ambient%20lighting%2C%20professional%20broadcast%20studio%20design%2C%20dark%20sophisticated%20interior%20with%20sports%20themed%20decor%2C%20clean%20minimalist%20aesthetic&width=800&height=600&seq=kaiyun-cat-spt-1&orientation=landscape',
    badge: '推荐',
  },
  {
    id: 'prod-sports-2',
    categoryId: 'sports',
    name: '竞技数据分析',
    description: '基于大数据与AI算法的竞技数据平台，多维度统计分析，助力深度洞察竞技趋势。',
    features: ['大数据分析', 'AI预测', '多维统计'],
    image: 'https://readdy.ai/api/search-image?query=Futuristic%20data%20analytics%20dashboard%20with%20warm%20amber%20glowing%20charts%20and%20graphs%2C%20modern%20corporate%20office%20design%2C%20multiple%20monitors%20displaying%20statistics%2C%20dark%20elegant%20interior%20with%20golden%20accent%20lighting%2C%20professional%20tech%20environment&width=800&height=600&seq=kaiyun-cat-spt-2&orientation=landscape',
  },
  {
    id: 'prod-sports-3',
    categoryId: 'sports',
    name: '互动竞技体验',
    description: '创新的互动竞技模式，结合实时数据反馈，让您以全新方式参与和感受竞技的魅力。',
    features: ['实时对战', '排行榜', '奖励机制'],
    image: 'https://readdy.ai/api/search-image?query=Exciting%20modern%20competitive%20gaming%20environment%20with%20warm%20dramatic%20lighting%2C%20professional%20esports%20arena%20design%2C%20dark%20sophisticated%20atmosphere%20with%20golden%20highlight%20accents%2C%20clean%20minimal%20geometric%20composition%2C%20energetic%20vibrant%20feel&width=800&height=600&seq=kaiyun-cat-spt-3&orientation=landscape',
  },
  {
    id: 'prod-life-1',
    categoryId: 'lifestyle',
    name: '精品商城',
    description: '严选全球优质品牌，从日常好物到轻奢精品，满足您对品质生活的所有想象。',
    features: ['正品保障', '全球直采', '品质严选'],
    image: 'https://readdy.ai/api/search-image?query=Elegant%20modern%20boutique%20store%20interior%20with%20warm%20golden%20track%20lighting%2C%20premium%20product%20displays%20on%20minimalist%20shelves%2C%20luxurious%20dark%20wood%20and%20marble%20textures%2C%20sophisticated%20retail%20design%2C%20soft%20atmospheric%20ambiance&width=800&height=600&seq=kaiyun-cat-life-1&orientation=landscape',
    badge: '精选',
  },
  {
    id: 'prod-life-2',
    categoryId: 'lifestyle',
    name: '旅行定制服务',
    description: '专业旅行规划师一对一服务，量身定制专属行程，让每一次出行都成为难忘的美好回忆。',
    features: ['专属定制', '专属管家', '全球资源'],
    image: 'https://readdy.ai/api/search-image?query=Luxurious%20modern%20travel%20scene%20with%20warm%20golden%20sunset%20light%2C%20elegant%20resort%20poolside%20setting%2C%20minimalist%20tropical%20architecture%20with%20dark%20wood%20accents%2C%20premium%20lifestyle%20travel%20aesthetic%2C%20soft%20atmospheric%20glow%20over%20water&width=800&height=600&seq=kaiyun-cat-life-2&orientation=landscape',
  },
  {
    id: 'prod-tech-1',
    categoryId: 'technology',
    name: '智能风控系统',
    description: '基于AI深度学习的智能风控引擎，实时监测异常行为，毫秒级响应潜在风险，全方位守护平台安全。',
    features: ['AI引擎', '实时监测', '毫秒响应'],
    image: 'https://readdy.ai/api/search-image?query=Futuristic%20AI%20security%20command%20center%20with%20warm%20golden%20neon%20data%20visualizations%2C%20multiple%20holographic%20display%20screens%2C%20dark%20sophisticated%20tech%20environment%2C%20clean%20minimalist%20dashboard%20design%2C%20premium%20corporate%20technology%20aesthetic&width=800&height=600&seq=kaiyun-cat-tech-1&orientation=landscape',
    badge: '新品',
  },
  {
    id: 'prod-tech-2',
    categoryId: 'technology',
    name: '分布式云架构',
    description: '全球节点部署的分布式云服务体系，智能负载均衡，确保低延迟、高可用的极致服务体验。',
    features: ['全球节点', '智能调度', '高可用性'],
    image: 'https://readdy.ai/api/search-image?query=Modern%20global%20network%20operations%20center%20with%20warm%20amber%20glowing%20server%20racks%2C%20sophisticated%20dark%20interior%20design%2C%20data%20center%20with%20clean%20cable%20management%2C%20premium%20technology%20infrastructure%2C%20soft%20atmospheric%20lighting&width=800&height=600&seq=kaiyun-cat-tech-2&orientation=landscape',
  },
];

export const categoryFAQ: Record<string, { id: string; question: string; answer: string }[]> = {
  entertainment: [
    { id: 'cf-e1', question: '娱乐服务支持哪些设备？', answer: '我们的娱乐服务支持PC端、移动App、平板等多种设备，您可以根据自己的使用习惯选择最便捷的访问方式，所有设备间的数据实时同步。' },
    { id: 'cf-e2', question: '如何获取最新的娱乐内容更新？', answer: '您可以关注开云官方公告和消息推送，我们会定期更新娱乐内容库。同时，智能推荐系统会根据您的偏好，第一时间为您呈现感兴趣的新内容。' },
  ],
  sports: [
    { id: 'cf-s1', question: '体育竞技数据更新频率是怎样的？', answer: '我们的体育竞技数据采用实时更新机制，关键赛事数据延迟控制在毫秒级别，确保您获取的信息始终是最新的。' },
    { id: 'cf-s2', question: '支持哪些体育项目的赛事覆盖？', answer: '目前覆盖足球、篮球、网球、电竞等超过30个体育项目，涵盖全球主流联赛和杯赛，赛事数量持续扩展中。' },
  ],
  lifestyle: [
    { id: 'cf-l1', question: '精品商城的商品是否支持退换货？', answer: '我们的精品商城提供7天无理由退换货服务，所有商品均经过严格质检，确保您收到的每一件商品都符合品质标准。' },
    { id: 'cf-l2', question: '旅行定制服务如何收费？', answer: '旅行定制服务根据行程复杂度、时长和个性化需求进行定价，您可以在提交需求后获得详细的报价方案，透明公开，无隐形费用。' },
  ],
  technology: [
    { id: 'cf-t1', question: '智能风控系统如何保护我的账户？', answer: '智能风控系统通过多维度行为分析、设备指纹识别、地理位置验证等技术手段，实时监控异常登录和操作行为，发现风险即时拦截并通知您。' },
    { id: 'cf-t2', question: '云架构的服务可用性如何保障？', answer: '我们采用多活架构，在全球多个区域部署服务节点，即使某个节点出现故障，系统也会自动切换到健康节点，确保服务不中断。' },
  ],
};